import React from 'react';
import styled from 'styled-components';

export default function Button({ text, width, height, padding, backgroundColor, border, borderRadius, fontSize, fontWeight, textColor, disabled = false, onClick, ...props }) {
  return (
    <StyledButton 
        $width={width}
        $height={height}
        $padding={padding}
        $backgroundColor={backgroundColor}
        $border={border}
        $borderRadius={borderRadius}
        $fontSize={fontSize}
        $fontWeight={fontWeight}
        $textColor={textColor}
        disabled={disabled}
        onClick={onClick}
        {...props}
    >
      {text}
    </StyledButton>
  );
}

const StyledButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  
    width: ${props => props.$width};
    height: ${props => props.$height};
    margin: ${props => props.$margin || '0'};
    padding: ${props => props.$padding};

    background-color: ${props => props.$backgroundColor};
    border:  ${props => props.$border || 'none'};
    border-radius: ${props => props.$borderRadius};

    font-size: ${props => props.$fontSize};
    font-weight: ${props => props.$fontWeight};
    color: ${props => props.$textColor};

    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;
